<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
        <router-link v-if="is_admin_dealer" to="/admin/manage/producers" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <router-link v-else to="/admin/producers" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
          <h3>Händler Details</h3>
        </div>
      </div>
      <div class="card-body">
        <div>
          <h3>Persönliche Daten</h3>
          <table class="provider-info-tbl">
            <tr>
              <td>Händler Name:</td>
              <td>{{ details.user_detail && details.user_detail.first_name ? details.user_detail.first_name + " " + details.user_detail.last_name:'-' }}</td>
            </tr>
            <tr>
              <td>E-Mail:</td>
              <td>{{ details.user_detail && details.user_detail.email ? details.user_detail.email:'-' }}</td>
            </tr>
            <tr>
              <td>Telefonnummer:</td>
              <td>{{ details.user_detail && details.user_detail.mobile_no ? details.user_detail.mobile_no : "-" }}</td>
            </tr>
          </table>
        </div>

        <div class="mt-5">
          <h3>Firmen Details</h3>
          <table class="provider-info-tbl" v-if="details">
            <tr>
              <td class="td-firmen-details">Firmenlogo:</td>
              <td>
                <img
                  :src="details.logo_path"
                  width="50px"
                />
              </td>
            </tr>
            <tr>
              <td class="td-firmen-details">Firmenname:</td>
              <td>
                {{
                  details.company_name
                    ? details.company_name
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td class="td-firmen-details">Firmenbeschreibung:</td>
              <td>
                <span
                  v-html="
                    details.description
                      ? details.description
                      : '-'
                  "
                ></span>
              </td>
            </tr>
            <tr>
              <td class="td-firmen-details">Firmen-Webseite:</td>
              <td>
                {{
                  details.website
                    ? details.website
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td class="td-firmen-details">Firmen Bilder:</td>
              <td v-if="details.categories && details.categories.pictures">
                <div class="row">
                  <div
                    v-for="(img, i) in details.pictures"
                    :key="'bgd' + i"
                  >
                    <img
                      class="mx-2"
                      :src="img.photo_path"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
              </td>
              <td v-else>-</td>
            </tr>
            <tr>
              <td class="td-firmen-details">Kategorien:</td>
              <td v-if="details.categories && details.categories.length > 0">
                <div class="row">
                  <ul>
                    <li
                      v-for="(cat, i) in details.categories"
                      :key="'jffd' + i"
                    >
                     <span v-if="cat.category_detail"> {{ cat.category_detail.category_name }} </span>
                    </li>
                  </ul>
                </div>
              </td>
              <td v-else>-</td>
            </tr>
            <tr>
              <td class="td-firmen-details">Adresse:</td>
              <td>
                {{
                  details.address
                    ? details.address
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td class="td-firmen-details">Stadt:</td>
              <td>
                {{
                  details.city
                    ? details.city
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td class="td-firmen-details">Postleitzahl:</td>
              <td>
                {{
                  details.postcode
                    ? details.postcode
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td class="td-firmen-details">Land:</td>
              <td>
                {{
                  details.country
                    ? details.country
                    : "-"
                }}
              </td>
            </tr>
            <!-- <tr v-if="details.general_setting && details.general_setting.term_and_conditions_pdf_path">
              <td>Mehrwertsteuersatz (%):</td>
              <td>
                <a :href="details.general_setting.term_and_conditions_pdf_path" target="_blank" v-if="details.general_setting.term_and_conditions_pdf_path !== ''">Allgemeine Geschäftsbedingungen des Händlers</a>
              </td>
            </tr> -->
            <tr v-if="details.general_setting && details.general_setting.term_and_conditions_pdf_path">
              <td class="td-firmen-details">Allgemeine Geschäftsbedingungen:</td>
              <td>
                <a :href="details.general_setting.term_and_conditions_pdf_path" target="_blank" v-if="details.general_setting.term_and_conditions_pdf_path !== ''">Allgemeine Geschäftsbedingungen des Händlers</a>
              </td>
            </tr>
          </table>
        </div>

        <div v-if="details">
          <div class="mt-5" v-if="details.payment_details">
            <h3>Zahlungsanbieter Details</h3>
            <table class="provider-info-tbl">
              <tr v-if="details.payment_details.stripe_public_key">
                <td>Stripe öffentlicher Schlüssel (Public Key):</td>
                <td>{{ details.payment_details.stripe_public_key }}</td>
              </tr>

              <tr v-if="details.payment_details.stripe_secret_key">
                <td>Stripe geheimer Schlüssel (Secret Key):</td>
                <td>{{ details.payment_details.stripe_secret_key }}</td>
              </tr>

              <tr v-if="details.payment_details.paypal_email">
                <td>PayPal E-Mail:</td>
                <td>{{ details.payment_details.paypal_email }}</td>
              </tr>

              <tr v-if="details.payment_details.mollie_key">
                <td>Mollie Schlüssel (Key):</td>
                <td>{{ details.payment_details.mollie_key }}</td>
              </tr>

              <tr v-if="details.payment_details.sumup_email">
                <td>SumUp E-Mail:</td>
                <td>{{ details.payment_details.sumup_email }}</td>
              </tr>

              <tr v-if="details.payment_details.klarna_api_username">
                <td>Klarna API Benutzername:</td>
                <td>{{ details.payment_details.klarna_api_username }}</td>
              </tr>

              <tr v-if="details.payment_details.klarna_api_password">
                <td>Klarna API Passwort:</td>
                <td>{{ details.payment_details.klarna_api_password }}</td>
              </tr>
            </table>
          </div>

          <div class="mt-5" v-if="details.general_setting">
            <h3>Lieferspesen-Optionen</h3>
            <table class="provider-info-tbl">
              <tr v-if="details.general_setting && details.general_setting.min_order_value && details.general_setting.min_order_value > 0">

                <td>Mindestbestellwert:</td>
                <td>€ {{details.general_setting.min_order_value | priceFormat}}</td>
                
              </tr>

              <tr v-if="details.general_transport_cost.length">
                <td>Lieferspesen-Optionen(Österreich):</td>

                
                <td>
                  <ul v-for="(transport_cost, i) in details.general_transport_cost"
                :key="i">
                    <li v-if="details.general_setting && details.general_setting.transport_cost_option === 'pieces'">
                      bis {{transport_cost.value | priceFormat}} Stück: € {{transport_cost.cost | priceFormat}} Versandkosten  
                    </li>
                    <li v-else>
                      bis € {{transport_cost.value | priceFormat}}: € {{transport_cost.cost | priceFormat}} Versandkosten  
                    </li>
                  </ul>
                  <p class="free-amount-text" v-if="details.general_setting && details.general_setting.transport_cost_option === 'amount' && details.general_setting
                              .transportation_cost_free_from !== 'null' && details.general_setting
                              .transportation_cost_free_from > 0"> 
                              Versandkostenfrei ab € {{details.general_setting
                            .transportation_cost_free_from | priceFormat}} 
                    </p>
                    <p class="free-amount-text" v-else-if="details.general_setting && details.general_setting.transport_cost_option === 'pieces' && details.general_setting
                                  .amount_grant_free_shipment !== 'null' && details.general_setting
                                  .amount_grant_free_shipment > 0"> 
                                  Versandkostenfrei ab €
                              {{details.general_setting
                                .amount_grant_free_shipment | priceFormat}}
                    </p>
                </td>
                
              </tr>

              <tr v-if="details.general_setting.is_abroad_shipping == '1' && details.abroad_shipping_transport_cost.length">
                <td>Lieferspesen-Optionen(Deutschland):</td>
                <td>
                  <ul v-for="(transport_cost, i) in details.abroad_shipping_transport_cost"
                :key="i">
                    <li v-if="details.general_setting && details.general_setting.abroad_transport_cost_option === 'amount'">
                      bis {{transport_cost.value | priceFormat}} Stück: € {{transport_cost.cost | priceFormat}} Versandkosten  
                    </li>
                    <li v-else>
                      bis € {{transport_cost.value | priceFormat}}: € {{transport_cost.cost | priceFormat}} Versandkosten  
                    </li>
                  </ul>
                  <p class="free-amount-text" v-if="details.general_setting && details.general_setting.abroad_transport_cost_option === 'amount' && details.general_setting
                              .abroad_transportation_cost_free_from !== 'null' && details.general_setting
                              .abroad_transportation_cost_free_from > 0"> 
                              Versandkostenfrei ab € {{details.general_setting
                            .abroad_transportation_cost_free_from | priceFormat}} 
                    </p>
                    <p class="free-amount-text" v-else-if="details.general_setting && details.general_setting.abroad_transport_cost_option === 'pieces' && details.general_setting
                                  .abroad_amount_grant_free_shipment !== 'null' && details.general_setting
                                  .abroad_amount_grant_free_shipment > 0"> 
                                  Versandkostenfrei ab €
                              {{details.general_setting
                                .abroad_amount_grant_free_shipment | priceFormat}}
                    </p>
                </td>
                
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showFileModal"
      class="file-modal"
      centered
      hide-footer
      resizable
    >
      <div v-if="modalFile">
        <div>
          <b-img :src="modalFile" class="modal-image"></b-img>
        </div>
      </div>
    </b-modal>
    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Please Confirm
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Status wirklich ändern?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            No
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Please Confirm
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            No
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="producres" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
//import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
//import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";

Vue.use(Notifications);

export default {
  name: "Producerdetails",
  props: {
    data: {
      type: String,
      required: true
    }
  },
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.producerId = this.$route.params.id;
      const customerPromise = this.getProducerDetails();
      Promise.all([customerPromise]);
    }
  },
  data() {
    return {
      is_admin_dealer:this.data ? this.data: 0,
      loading_details: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchNameKey: "",
      //searchAddressKey: "",
      //searchPriceKey: "",
      searchStatusKey: "",
      searchUnitKey: "",
      producerId: "",
      userId: null,
      showFileModal: false,
      modalFile: null,
      details: [],
      statusItems: [
        {
          title: "Draft",
          value: "0",
        },
        {
          title: "Confirmation Pending",
          value: "1",
        },
        {
          title: "Online",
          value: "2",
        },
        {
          title: "Offline",
          value: "3",
        },
      ],
      unitsList: [],
      deleteRecordId: null,
      statusDialog: false,
      deleteDialog: false,
      statusRecordId: null,
      yesActionLoading: false,
      disabledCancel: false,
      newStatus: null,
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  components: {
    // 'money-format': MoneyFormat
  },
  watch: {
    searchNameKey: {
      handler: function (val, oldVal) {
        this.details = [];
        this.loading_details = true;
        this.getProducerDetails();
      },
      deep: true,
    },
    /*searchAddressKey: {
      handler: function (val, oldVal) {
        this.properties = [];
        this.loading_details = true;
        this.getProducerDetails();
      },
      deep: true,
    },*/
    /*searchPriceKey: {
      handler: function (val, oldVal) {
        this.details = [];
        this.loading_details = true;
        this.getProducerDetails();
      },
      deep: true,
    },*/
    searchStatusKey: {
      handler: function (val, oldVal) {
        this.details = [];
        this.loading_details = true;
        this.getProducerDetails();
      },
      deep: true,
    },
    searchUnitKey: {
      handler: function (val, oldVal) {
        this.details = [];
        this.loading_details = true;
        this.getProducerDetails();
      },
      deep: true,
    },
  },
  methods: {
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },  
    openFileModal(file) {
      this.showFileModal = true;
      this.modalFile = file;
    },   
    getProducerDetails() {
      adminAPI
        .getProducerDetails(this.$route.params.id)
        .then((response) => {
          if (response.status == "success") {
            this.details = response.data;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_details = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_details = false;
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_details = false;
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },/*
    deleteproperty(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },*/
    deleteRecord(id) {
      this.deleteDialog = false;
      this.deleteRecordId = null;
      axios
        .post("delete-property", { id: id })
        .then((response) => {
          var responseJson = response.data;
          if (responseJson.status == "success") {
            this.$notify({
              group: "producres",
              type: "success",
              position: "bottom right",
              text: responseJson.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getProducerDetails();
          } else {
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeStatus(id, status) {
      if (status == 1) {
        this.newStatus = "2";
      } else if (status == 2) {
        this.newStatus = "3";
      }
      // else if (status == 3) {
      //   this.newStatus = "2";
      // }
      this.statusDialog = true;
      this.statusRecordId = id;
    },
    changeStatusRecord(id, status) {
      this.yesActionLoading = true;
      this.disabledCancel = true;

      adminAPI
        .statusProduct({ id: id, status: status })
        .then((response) => {
          if (response.status == "success") {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producres",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.getProducerDetails();
          } else {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producres",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.statusDialog = false;
          this.statusRecordId = null;
          this.newStatus = null;
          this.yesActionLoading = false;
          this.disabledCancel = false;
          this.$notify({
            group: "producres",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80;
}

li {
  list-style: disc;
}

.invite-btn:hover {
  background-color: #002c47;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}
.free-amount-text{
  font-size: 13px;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}
.td-firmen-details{
  width: 17%;
}
</style>